<header class="header container-fluid">
  <nav class="navbar navbar-expand-lg navbar-light bg-white">

    <!-- Logo -->
    <a class="navbar-brand" routerLink="/">
      <img
        src="logo.png"
        alt="Logo"
        class="header_content_logo"
      />
    </a>

    <!-- Mobile Toggle -->
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarContent"
      aria-controls="navbarContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Menu -->
    <div class="collapse navbar-collapse" id="navbarContent" #navbar>
      <div class="ms-auto d-flex flex-column flex-lg-row gap-2 align-items-lg-center">
        <button
          class="header_content_button"
          [ngClass]="{ 'active': router.url === '/' }"
          type="button"
          (click)="navigateAndClose('/')"
        >
          Home
        </button>

        <button
          class="header_content_button"
          type="button"
          (click)="contactAndClose()"
        >
          Contact Us
        </button>

        <button
          matButton="filled"
          color="primary"
          class="header_content_qr-button"
          (click)="navigateAndClose('/generate-qr')"
        >
          Generate QR
        </button>
      </div>
    </div>
  </nav>
</header>